import { render } from "./vendas_fei_detalhe.vue?vue&type=template&id=c0434902"
import script from "./vendas_fei_detalhe.vue?vue&type=script&lang=js"
export * from "./vendas_fei_detalhe.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__